










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { SurveyModel, createTOCListModel, getTocRootCss, TOCModel } from "survey-core";

@Component
export class ProgressToc extends Vue {
  @Prop() model: TOCModel;
  @Prop() survey: SurveyModel;
  @Prop() css: any;
  constructor() {
    super();
  }
}

Vue.component("sv-navigation-toc", ProgressToc);
export default ProgressToc;
